import { create } from 'zustand';
import type { LootKind } from '@estandarte/engine';
import type { CardDesc } from '../game/Cards';

export type HudPanel = 'regions' | 'log' | 'rules' | 'menu';

interface UiStore {
  selected: string | null;
  target: string | null;
  bossTarget: boolean;
  /** Carta de loot sendo jogada e os territórios já escolhidos para ela. */
  loot: LootKind | null;
  picks: string[];
  amount: number | 'all';
  showMission: boolean;
  cardsPicked: string[];
  /** Painel aberto pela barra do canto superior direito. */
  panel: HudPanel | null;
  /** Card do boss no mapa aberto (detalhes). */
  bossOpen: boolean;
  /** Jogador com a ficha (biografia) aberta. */
  bio: number | null;
  setBio(player: number | null): void;
  /** Carta ampliada ao passar o mouse. */
  inspect: { desc: CardDesc; rect: DOMRect } | null;
  setInspect(inspect: { desc: CardDesc; rect: DOMRect } | null): void;
  setPanel(panel: HudPanel | null): void;
  setBossOpen(open: boolean): void;
  select(id: string | null): void;
  setTarget(id: string | null): void;
  setBossTarget(on: boolean): void;
  startLoot(kind: LootKind | null): void;
  setPicks(picks: string[]): void;
  setAmount(a: number | 'all'): void;
  toggleMission(show?: boolean): void;
  toggleCard(card: string): void;
  clearCards(): void;
  reset(): void;
}

export const useUi = create<UiStore>((set) => ({
  selected: null,
  target: null,
  bossTarget: false,
  loot: null,
  picks: [],
  amount: 1,
  showMission: false,
  cardsPicked: [],
  panel: null,
  bossOpen: false,
  bio: null,
  setBio: (bio) => set((s) => ({ bio: s.bio === bio ? null : bio })),
  inspect: null,
  setInspect: (inspect) => set({ inspect }),
  setPanel: (panel) => set((s) => ({ panel: s.panel === panel ? null : panel })),
  setBossOpen: (bossOpen) => set({ bossOpen }),
  select: (selected) => set({ selected, target: null, bossTarget: false }),
  setTarget: (target) => set({ target, bossTarget: false }),
  setBossTarget: (bossTarget) => set({ bossTarget, target: null }),
  startLoot: (loot) => set({ loot, picks: [], selected: null, target: null, bossTarget: false }),
  setPicks: (picks) => set({ picks }),
  setAmount: (amount) => set({ amount }),
  toggleMission: (show) => set((s) => ({ showMission: show ?? !s.showMission })),
  toggleCard: (card) =>
    set((s) => ({
      cardsPicked: s.cardsPicked.includes(card)
        ? s.cardsPicked.filter((c) => c !== card)
        : [...s.cardsPicked, card].slice(-3),
    })),
  clearCards: () => set({ cardsPicked: [] }),
  reset: () => set({ selected: null, target: null, bossTarget: false, loot: null, picks: [], cardsPicked: [] }),
}));
